import { render } from "./MoblileHeader.vue?vue&type=template&id=23685d48&scoped=true"
import script from "./MoblileHeader.vue?vue&type=script&lang=js"
export * from "./MoblileHeader.vue?vue&type=script&lang=js"

import "./MoblileHeader.vue?vue&type=style&index=0&id=23685d48&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23685d48"]])

export default __exports__